import React from 'react';

import PaywallContent from './PaywallContent';

export const WPPayPlans = () => {

    return (
        <div
            className={`bg-cosmicLatte-primary w-full text-forest-primary overflow-x-hidden pt-4 md:pt-10 min-h-[calc(100vh-var(--rebrand-banner-height,0px))]`}
        >
            <PaywallContent />
        </div>
    )
}